import type { FC } from 'react';
import { useState } from 'react';
import { Box } from '@mui/material';

import type { DetailedFollowUpTicket } from 'src/types/followUp';
import type { SurveyDetail } from 'src/types/survey';
import FollowUpCallSection from 'src/components/followUp/TicketOverviewPage/TicketDetail/FollowUpCallSection/FollowUpCallSection';

import ChangelogSection from './ChangelogSection/ChangelogSection';
import CommentSection from './CommentSection/CommentSection';
import RespondentOverviewSection from './RespondentOverviewSection/RespondentOverviewSection';

import { styles } from './ticketDetail.styles';

interface ModalContentMainProps {
  ticket: DetailedFollowUpTicket;
  survey?: SurveyDetail;
  refetchList: () => void;
}

const ModalContentMain: FC<ModalContentMainProps> = ({
  ticket,
  survey,
  refetchList,
}) => {
  const [changelogExtended, setChangelogExtended] = useState(true);

  if (!ticket) return null;

  return (
    <Box sx={{ width: '70%', ...styles.scrollContainer }}>
      <Box sx={styles.modalMain}>
        <RespondentOverviewSection ticket={ticket} survey={survey} />

        <FollowUpCallSection
          ticket={ticket}
          survey={survey}
          refetchList={refetchList}
        />

        <CommentSection
          ticket={ticket}
          onCommentSave={() => setChangelogExtended(true)}
        />

        <ChangelogSection
          ticket={ticket}
          extended={changelogExtended}
          toggleExtended={() => setChangelogExtended((prev) => !prev)}
        />
      </Box>
    </Box>
  );
};

export default ModalContentMain;
